import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

// A minimal custom cursor: a small dot that follows the pointer and expands
// into a "VIEW" pill over artworks. Desktop / fine-pointer only (gated by App).
export default function CustomCursor() {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const springX = useSpring(x, { stiffness: 500, damping: 40, mass: 0.4 });
  const springY = useSpring(y, { stiffness: 500, damping: 40, mass: 0.4 });

  const [active, setActive] = useState(false);
  const [label, setLabel] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add("has-custom-cursor");

    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      if (!visible) setVisible(true);
      const target = e.target.closest("[data-cursor]");
      if (target) {
        setActive(true);
        setLabel(target.getAttribute("data-cursor") || "");
      } else {
        setActive(false);
        setLabel("");
      }
    };
    const leave = () => setVisible(false);

    window.addEventListener("mousemove", move);
    document.addEventListener("mouseleave", leave);
    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseleave", leave);
      document.documentElement.classList.remove("has-custom-cursor");
    };
  }, [x, y, visible]);

  return (
    <motion.div
      className="custom-cursor"
      style={{ left: springX, top: springY, opacity: visible ? 1 : 0 }}
      data-testid="custom-cursor"
      aria-hidden="true"
    >
      <motion.div
        className="custom-cursor__inner"
        animate={{
          width: active ? 88 : 10,
          height: active ? 88 : 10,
          backgroundColor: active ? "rgba(28,28,26,0.92)" : "rgba(28,28,26,1)",
        }}
        transition={{ type: "spring", stiffness: 300, damping: 26 }}
      >
        <motion.span
          className="custom-cursor__label"
          animate={{ opacity: active ? 1 : 0 }}
          transition={{ duration: 0.2 }}
        >
          {label}
        </motion.span>
      </motion.div>
    </motion.div>
  );
}
